// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Mask_wrapper__1XfFO","mask":"Mask_mask__1p6Z5","show":"Mask_show__e9Gse"};